<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.jpg" width="100%"  />
	</div>
</div>

<div class="wapper overf">
	<div class="part main-box2 t-center" style="background:#fff; padding:50px; height:500px;">
        <p class="f20 cGreen2 b h44">提交成功！</p>
        <p class="h44">您的查询码：</p>
        <p class=" f26 cGray3 b h44">{{queryCode}}</p>
        <p class="h44 cRed">请务必保存好您的查询码！这是查询结果的唯一凭证！</p>
</div>
</div>






<div class="clear overf m_t_40"></div>
<!---- foot ---->
<div class="wapper overf p_b_10" style="background:#AD0C1D;" >
  <div class="part p_t_20 h26 cWhite f14 overf" >
	  <div class="t-center">	
              <p class=" p_l_10 ">
Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
			  </p>
        <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
     </div>
</div>
</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      queryCode:"",
    }
  },
  mounted(){
	this.queryCode=this.$route.params.queryCode
  },
  methods:{
      notice(code){
          this.$router.push({name:'notice',params:{areaCode:code}})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#sz_btn{ width:90%; display:block; margin:0 auto; text-align:center;}
#sz_btn a{ display:inline-block; margin:25px; }
#sz_btn .szbk{background: url(../../static/img/sz_btn_bk2.png) left top no-repeat; width:185px; height:85px; line-height:30px; font-size:16px; color:#333; padding:8px 0;}
#sz_btn a:hover .szbk{ color:#fff; background:url(../../static/img/xq_btn_bk2.png) left top no-repeat;}

</style>



// WEBPACK FOOTER //
// src/views/cxm.vue